import {
  ApplicationIdPathParam,
  IfpApplicationActionPathParams,
  IfpApplicationActionRequest,
  IfpApplicationActionResponse,
  IfpApplicationIdPathParam,
  IfpApplicationMetadata,
  IfpCreateApplicationRequest,
  IfpCreateApplicationResponse,
  IfpGetApplicationResponse,
  IfpUpdateApplicationRequest,
} from '@shared/sec-loans'
import { Endpoint, SignApplicationResponse } from '@shared/types'

export const ENDPOINT_IFP_GET_APPLICATION: Endpoint<IfpGetApplicationResponse, void, never, ApplicationIdPathParam> = {
  path: '/ifp/application/{applicationId}',
  method: 'get',
}

export const ENDPOINT_IFP_GET_APPLICATIONS: Endpoint<IfpApplicationMetadata[]> = {
  path: '/ifp/applications',
  method: 'get',
}

export const ENDPOINT_IFP_CREATE_APPLICATION: Endpoint<IfpCreateApplicationResponse, IfpCreateApplicationRequest> = {
  path: '/ifp/application',
  method: 'post',
}

export const ENDPOINT_IFP_UPDATE_APPLICATION: Endpoint<
  void,
  IfpUpdateApplicationRequest,
  never,
  ApplicationIdPathParam
> = {
  path: '/ifp/application/{applicationId}',
  method: 'put',
}

export const ENDPOINT_IFP_APPLICATION_ACTION: Endpoint<
  IfpApplicationActionResponse,
  IfpApplicationActionRequest,
  never,
  IfpApplicationActionPathParams
> = {
  path: '/ifp/application/{applicationId}/action/{action}',
  method: 'put',
}

export const ENDPOINT_SIGN_IFP_APPLICATION: Endpoint<SignApplicationResponse, never, never, IfpApplicationIdPathParam> =
  {
    path: '/ifp/application/{applicationId}/signing-url',
    method: 'get',
  }
